import request from '@/request/request'

/**
 *  推荐房源
 * @param {} parameter 
 * @returns 
 */
export function recommendHouse (parameter) {
  return request({
    url: '/e-find/recommendHouse2',
    method: 'post',
    data: parameter
  })
}

/**
 *  地图找房
 * @param {} parameter 
 * @returns 
 */
export function listMapAsset (parameter) {
  return request({
    url: '/e-find/mapFindHouse2',
    method: 'post',
    data: parameter
  })
}

/**
 *  房源详情
 * @param {} parameter 
 * @returns 
 */
export function getHouseDetail (parameter) {
  return request({
    url: '/e-find/getHouseDetail2',
    method: 'get',
    data: parameter
  })
}

/**
 *  帮我找房
 * @param {} parameter 
 * @returns 
 */
export function helpFindHouse (parameter) {
  return request({
    url: '/e-find/helpFindHouse',
    method: 'post',
    data: parameter
  })
}

/**
 *  服务点
 * @param {} parameter 
 * @returns 
 */
export function listServicePoint (parameter) {
  return request({
    url: '/e-find/servicePoint',
    method: 'get',
    data: parameter
  })
}

/**
 *  咨询列表
 * @param {} parameter 
 * @returns 
 */
export function getNewDetail (parameter) {
  return request({
    url: '/e-find/getNewDetail',
    method: 'post',
    data: parameter
  })
}